import { ApiKeys } from '@app/constants/api-keys'
import { IEducationLanguage } from '@app/interfaces/education/education-language'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localforage from 'localforage'
import { IRtkResponse } from '../../types'
import { emptyEducationApi } from './index'

export const educationLanguageApi = emptyEducationApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getEducationLanguages: build.query<
      IRtkResponse<IEducationLanguage[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'dictionary/api/v1/education-language',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IEducationLanguage[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.educationLanguage,
                id,
              })),
              { type: ApiKeys.educationLanguage, id: 'LIST' },
            ]
          : [{ type: ApiKeys.educationLanguage, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.educationLanguage, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getEducationLanguage: build.query<IEducationLanguage, number>({
      query: (id) => ({
        url: `dictionary/api/v1/education-language/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [
        { type: ApiKeys.educationLanguage, id },
      ],
    }),
  }),
})

export const { useGetEducationLanguagesQuery, useGetEducationLanguageQuery } =
  educationLanguageApi
